import { ApiError, NETWORK_ERROR, apiErrorFrom } from "@/shared/api/errors";

interface EmptyResult {
  error?: unknown;
  response: Response;
}

/**
 * Wait for a call whose envelope carries no data (`data: null`, such as a delete), or throw an
 * ApiError like `unwrap` does.
 */
export async function unwrapEmpty(request: Promise<EmptyResult>): Promise<void> {
  let result: EmptyResult;
  try {
    result = await request;
  } catch {
    throw new ApiError(NETWORK_ERROR, "Network request failed", 0);
  }
  if (!result.response.ok) throw apiErrorFrom(result.error, result.response);
}
